import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import FormHelper from '../helpers/form.helper';

@Component({})
export default class BaseFilter extends Vue {
  form: Object = {};

  protected created() {
    this.addEventListener();
    this.getDictionaries();
  }

  addEventListener() {
    const self = this;

    window.addEventListener('keydown', (e: any) => {
      if (e.key == 'Enter' && self.$route.name != 'PatientEdit' && e.target.type != 'textarea') {
        self.search();
        e.preventDefault();
      }
    });
  }

  search() {
    this.$emit('search', this.form);
  }

  getDictionaries() {}

  reset(e: Event, callback: any) {
    e.stopPropagation();
    this.$emit('reset');
    this.form = FormHelper.resetFields(this.form);
    if (callback) {
      callback();
    }
    this.search();
  }
}
